'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 50" {...props}><path fill="currentColor" d="M47.031 9.102q.037.265.037.54v32a4 4 0 0 1-4 4H10.491l4-4h17.916l-8.958-8.958 2.828-2.828 2.874 2.874 3.675-3.674a6 6 0 0 1 8.484 0l1.758 1.758V13.065zm-11.853.54H7.068v14.72l2.615-2.615a6 6 0 0 1 8.485 0l2.452 2.452-2.828 2.828-2.452-2.452a2 2 0 0 0-2.828 0l-5.444 5.443v7.733L3.07 41.75l-.002-.107v-32a4 4 0 0 1 4-4h32.11zm3.304 22.242a2 2 0 0 0-2.828 0L31.98 35.56l6.083 6.083h5.005V36.47zm2.18-16.413a6 6 0 0 1-7.764 7.764z" /><rect width={64.911} height={4} x={0.635} y={46.535} fill="currentColor" rx={2} transform="rotate(-45 .635 46.535)" /></svg>;
const IconImgBroken = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconImgBroken;